import { addValidationRule } from 'formsy-react';
import { ADVANCE_DEALER_PAID, MAX_ADVANCE_LOAN_VALUE } from '../../../config/constants';

export const registerComputationFormsyValidationRules = () => {
    addValidationRule("percentageValidation", (values, value) => {
        if (value > 100) {
            return "Percentage value must be less than 100";
        }
        else if (value < 0) {
            return "Value should be greater than 0";
        }
        return true;
    });
    
    addValidationRule("vatValidation", (values, value) => {
        if (value > 50 && values.exclusive_per && values.inclusive_per) {
            return "Percentage value must be less than or equal to 50";
        }
        else if (value <= 0) {
            return "Value should be greater than 0";
        }
        return true;
    });
    
    addValidationRule("dpValidation", (values, value) => {
        if (Number(value) >= Number(values.fmv)) {
            return "Amount must be less than FMV";
        }
        else if (value < 0) {
            return "Value should be greater than 0";
        }
        return true;
    });
    
    addValidationRule("negativeValidation", (values, value) => {
        if (value <= 0) {
            return "Value should be greater than 0";
        }
        return true;
    });
    
    addValidationRule("negativeValue", (values, value) => {
        if (value < 0) {
            return "Value cannot be negative";
        }
        return true;
    });
    
    addValidationRule("adp_surcharge", (values, value) => {
        const { min, max } = ADVANCE_DEALER_PAID.ADP_SURCHARGE;
        if (value < min || value > max) {
            return `Value should be between ${min} to ${max}`;
        }
        return true;
    });
    
    addValidationRule("adp_title_transfer", (values, value) => {
        const { min, max } = ADVANCE_DEALER_PAID.TITLE_TRANSFER_CHARGE;
        if (value < min || value > max) {
            return `Value should be between ${min} to ${max}`;
        }
        return true;
    });
    
    addValidationRule("adp_max_capped", (values, value) => {
        if (value > MAX_ADVANCE_LOAN_VALUE) {
            return `Max capped value is ${MAX_ADVANCE_LOAN_VALUE}`;
        }
        if (value < 1) {
            return "Value cannot be negative or zero";
        }
        return true;
    });
    
    addValidationRule("adp_percentage_range", (values, value) => {
        if (value > ADVANCE_DEALER_PAID.ADP_PERCENTAGE_RANGE.max) {
            return `Max value is ${ADVANCE_DEALER_PAID.ADP_PERCENTAGE_RANGE.max}`;
        }
        if (value < ADVANCE_DEALER_PAID.ADP_PERCENTAGE_RANGE.min) {
            return `Min value is ${ADVANCE_DEALER_PAID.ADP_PERCENTAGE_RANGE.min}`;
        }
        return true;
    });
    
    // is Valid total amount paid
    addValidationRule('isValidDSTcharges', function (values, value) {
        return value >= 0 && value <= 100000 ? true : 'DST Charges should be in Between 0-100000';
    });

    addValidationRule("requestedTaxDeductionValidation", (values, value) => {
        const maxAllowed = Number(values?.di_amount_from_financier_to_carmudi_tax_percent || 0);
        if (value > maxAllowed) {
            return `Requested WHT deduction on DI % cannot exceed actual DI WHT %`;
        }
        return true;
    });


    addValidationRule('isValidPercentageWithGreaterZero', function (values, value) {
        return value > 0 && value < 100 ? true : 'Percentage should be in Between 0-100';
    });

    addValidationRule("fromMainDealerValidation", (values, value) => {
        const finalLoanValue = Number(values?.final_loan_value || 0);
        console.log("Pankaj finalLoanValue................",finalLoanValue)
        if (Number(value) > finalLoanValue) {
            return "From Main Dealer cannot be greater than Final Loan Value";
        }
        return true;
    });

    addValidationRule("fromSplitPaymentsValidation", (values, value) => {
        const dealerIncentive = Number(values?.dealer_incentive_net_of_tax || 0);
        if (Number(value) > dealerIncentive) {
            return "From Split Payments cannot be greater than Dealer Incentive Net Of Tax";
        }
        return true;
    });

    addValidationRule("finssoTotalValidation", (values, value) => {
        const totalSent = Number(values?.total_amount_sent_to_finsso || 0);
        const mainDealer = Number(values?.from_main_dealer || 0);
        const splitPayments = Number(values?.from_split_payments || 0);
        const finalLoanValue = Number(values?.final_loan_value || 0);
        const dealerIncentive = Number(values?.dealer_incentive_net_of_tax || 0);
        const sum = mainDealer + splitPayments;
        // Special Case
        if(totalSent <= 0){
            return "Amount Must Be Greater Than Zero";
        }
        if (mainDealer === finalLoanValue && splitPayments === dealerIncentive) {
            if (sum > totalSent) {
                return "Sum of Main Dealer and Split Payments cannot exceed Total Amount Sent to FINSSO";
            }
        } else {
            if (sum !== totalSent) {
                return "Main Dealer + Split Payments must equal Total Amount Sent to FINSSO";
            }
        }
        return true;
    });
};